import type React from 'react';

import { Button, HeroLayout, Image, Text } from '@change/ds-core-ui';

import { useGetStaticAssetUrl } from '@change-corgi/core-react/assets';
import { Translate, useI18n } from '@change-corgi/core-react/i18n';

import { Waypoint } from '#src/app/shared/components/scroll';

import { useContributeSection } from './hooks/useContributeSection';

export const ContributeSection: React.FC = () => {
	const { translate } = useI18n();
	const {
		actions: { onCtaClick, onSectionView },
	} = useContributeSection();
	const getStaticAssetUrl = useGetStaticAssetUrl();

	return (
		<HeroLayout
			variant="1/2"
			data-testid="homepage-contribute-section"
			reverseMd
			className="bg-background-raised text-typography-strong"
			media={
				<picture className="block h-full w-full">
					<source
						type="image/webp"
						srcSet={`${getStaticAssetUrl('/homepageV3/homepage-contribute@1x.webp')} 1x, ${getStaticAssetUrl('/homepageV3/homepage-contribute@2x.webp')} 2x, ${getStaticAssetUrl('/homepageV3/homepage-contribute@3x.webp')} 3x`}
					/>
					<Image
						alt={translate('corgi.homepage.contribute_section.image.alt_text')}
						src={getStaticAssetUrl('/homepageV3/homepage-sunrise-contribute@1x.png')}
						srcSet={`${getStaticAssetUrl('/homepageV3/homepage-sunrise-contribute@1x.png')} 1x, ${getStaticAssetUrl('/homepageV3/homepage-sunrise-contribute@2x.png')} 2x, ${getStaticAssetUrl('/homepageV3/homepage-sunrise-contribute@3x.png')} 3x,`}
						loading="lazy"
						className="bg-background-raised h-full w-full object-cover"
					/>
				</picture>
			}
		>
			<div className="flex flex-col items-start gap-6 p-8 md:p-12">
				<div>
					<Waypoint onEnter={onSectionView} />
					<Text as="h2" data-qa="contribute-section-title" variant="heading" size="large">
						<Translate value="corgi.homepage.contribute_section.title" />
						<br />
						<Translate value="corgi.homepage.contribute_section.subtitle" />
					</Text>
				</div>
				<Text variant="body">
					<Translate value="corgi.homepage.contribute_section.description" />
				</Text>

				<Button data-qa="homepage-contribute-section-cta" onClick={onCtaClick} as="a" href="/member/join">
					<Translate value="corgi.homepage.contribute_section.cta_btn" />
				</Button>
			</div>
		</HeroLayout>
	);
};
